import angular from 'angular';
import TimePickerDirective from './time-picker.directive';
import './time-picker.scss'

let TimePickerModule = angular.module('time-picker-module', [])

    .directive('timePicker', TimePickerDirective)

    .name;

export default TimePickerModule;


// WEBPACK FOOTER //
// ./client/app/common/ui/time-picker/index.js